import React, { useContext, useEffect, useState } from 'react'
import Line from "../../../assets/images/line.png"
import Icon1 from "../../../assets/images/we-do-icon-1.png"
import ServiceCard from '../../Reusable/ServiceCard'
import { axiosInstance, config } from '../config'
import { Link } from 'react-router-dom'
import { ServicesContext } from '../../Reusable/ServiceContextmain'

const WhatWeDo = () => {

    const [Loading, setLoading] = useState(false);

    const { services, loading, error } = useContext(ServicesContext);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    
    return (
        <div>
            <div className="rs-services services-style1 bg2 pt-115 pb-120 md-pt-75 md-pb-80" >
                <div className="container">
                    <div className="sec-title mb-65 text-center">
                        <span className="sub-text">What We Do</span>
                        <h2 className="title">
                            Our Most Popular Cleaning <br /> <span> Services </span> For You
                        </h2>
                        <div className="line-img ser-center wow fadeInUp">
                            <img src={Line} alt="Images" />
                        </div>
                    </div>
                    <div className="row y-middle">
                        {services?.slice(0,3)?.map((obj, i) => {
                            return (
                                <ServiceCard obj={obj} key={i} icon={Icon1} />
                            )
                        })}
                    </div>
                    <div className="btn-part wow fadeInUp text-center" >
                        <Link to={`${config.appUrl}services`} className="readon view" >View All Services</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default WhatWeDo
